<template>

<div :class="headless ? '' : 'card'">
    <div :class="headless ? '' : 'card-body'">
    
    <div v-if="addresses.length == 0"><button class="btn btn-danger col" @click="showModalNewAddress()">Add new address</button></div>
    <div class="row" v-else>
      <div class="col" v-if="!headless"><div class="pb-2"><b class="mr-3">My addresses</b></div></div>
      <div class="col text-right"><a href="#/" @click="showModalNewAddress()" style="color:#0b79bf;">Add new address</a></div>
    </div>

    <table class="table mt-3" v-if="addresses.length > 0">
        <tbody>
        <tr v-for="(address, index) in addresses" :key="index">
            <td :class="`px-2 selected_${address.selected}`">
    
    <div class="receiver">{{address.receiver_name}} {{address.receiver_phone}}</div>
    <div><span v-if="address.building">{{address.building}}, </span><span v-if="address.unit_number">{{address.unit_number}}, <span v-if="address.street_address">{{address.street_address}}, </span><span v-if="address.business_name">{{address.business_name}}, </span></span><span v-if="address.suburb">{{address.suburb}}, </span><span v-if="address.city">{{address.city}}, </span><span v-if="address.province">{{address.province}}, </span><span v-if="address.postal_code">{{address.postal_code}}</span></div>
    <div>
      <div class="row">
        <div class="col">
          <a href="#/" @click="showModalEditAddress(address)" style="color:#0b79bf;">Edit</a>
          <span v-if="address.selected == 0">  &bull; <a href="#/" @click="selectAddress(address.id)" style="color:#0b79bf;">Select</a></span>
        </div>
        <div class="col text-right"><a href="#/" v-if="address.selected == 0" @click="deleteAddress(address.id)" style="color:#0b79bf;">Delete</a></div>
      </div>
    </div>
            </td>
        </tr>
        </tbody>
    </table>

    <div class="mt-3" v-if="addresses.length > 0 && !headless"><button class="btn btn-success col" @click="closeAddresses">Continue</button></div>

    </div>

    <new-address-modal ref="NewAddressModal" @get-addresses="getMyAddresses"></new-address-modal>
    <edit-address v-if="addressInfo" :address="addressInfo"></edit-address>
</div>

</template>

<script>
import { EventBus } from '../bus';

export default {
props: ['headless'],
  data() {
    return {
      addresses: [],
      addressInfo: {},
    };
  },

  mounted() {
    this.getMyAddresses();

    EventBus.$on('get-my-addressses', () => {
      this.getMyAddresses();
    });
  },

  methods: {

    deleteAddress(address_id) {

        Swal.fire({
        title: 'Are you sure you want to delete this address?',
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Yes, delete it',
        customClass: { title: "popup-title"},
      }).then((result) => {

      if (result.isConfirmed) {
          this.deleteAddressAction(address_id);
        } 

      })

    },

    deleteAddressAction(address_id) {

      let existingObj = this;

      axios
        .post('/address/delete', {address_id: address_id})
        .then(function (response) {
          if (response.data.success) {
            existingObj.getMyAddresses();
          } else {
            existingObj.sweetfire(response.data.message);
          }
        });

    },

    showModalNewAddress() {
      this.$refs.NewAddressModal.clearInfo();
      this.$bvModal.show('bv-modal-new-address');
    },

    showModalEditAddress(address) {
      this.addressInfo = address;
      this.$bvModal.show('bv-modal-edit-address');
    },

    selectAddress(id) {

        axios
        .post('/address/choose', {
          address_id: id
        })
        .then((response) => {
          
            this.addresses.forEach((address) => {
            address.selected = 0;
            if (address.id === id) {
            address.selected = 1;
            }
            });

        });
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: "Ok",
        customClass: {
          title: "popup-title",
        },
      });
    },

    closeAddresses() {
      this.$emit('close-addresses');
    },

    getMyAddresses() {
      axios
        .get('/address/list')
        .then((response) => {
          this.addresses = response.data;
        });
    },

    },
};
</script> 

<style scoped>
.receiver { background: #f1f3f4;display:initial; }
.addrow:hover { background: #e5f5ff; cursor: pointer; }
.selected_1 { background: #e5f5ff;}
</style>
